import { render, staticRenderFns } from "./PageNavigationBar.vue?vue&type=template&id=3216d62c"
import script from "./PageNavigationBar.ts?vue&type=script&lang=ts&external"
export * from "./PageNavigationBar.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports